let markerClusterPromise: Promise<void> | null = null;

// Call after DG.then(): the plugin extends the global Leaflet API supplied by 2GIS.
export const loadMarkerCluster = (): Promise<void> => {
  if (!markerClusterPromise) {
    markerClusterPromise = import('leaflet.markercluster')
      .then(() => {
        if (typeof window.DG?.markerClusterGroup !== 'function') {
          throw new Error('2GIS marker clustering is unavailable');
        }
      })
      .catch((error) => {
        markerClusterPromise = null;
        throw error;
      });
  }

  return markerClusterPromise;
};
